import React from "react";
import styles from "./styles.module.scss";
import { ArrowLeft, ArrowRightIcon } from "assets";

export interface PaginationTwoProps {
  className?: string;
  current: number;
  total: number;
  handleChange: (page: number) => void;
  count: number;
  length: number;
}

const PaginationTwo: React.FC<PaginationTwoProps> = ({
  current,
  total,
  handleChange,
  className,
}) => {

  const handleIncrease = () => {
    if (current < total) handleChange(current + 1);
  };

  const handleDecrease = () => {
    if (current > 1) handleChange(current - 1);
  };

const renderPages = () => {
  if (total <= 6) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  if (current <= 3) {
    return [1, 2, 3, "...", total - 2, total - 1, total];
  }

  if (current >= total - 2) {
    return [1, 2, 3, "...", total - 2, total - 1, total];
  }

  return [1, "...", current - 1, current, current + 1, "...", total];
};

  return (
    <nav className={`${styles.pagination} ${className || ""}`}>
      <button
        onClick={handleDecrease}
        disabled={current === 1}
        className={styles.navBtn}
      >
        <ArrowLeft className={styles.leftArrow} />
        Previous
      </button>

      <ul className={styles.pages}>
        {renderPages().map((page, idx) =>
          page === "..." ? (
            <li key={`ellipsis-${idx}`} className={styles.ellipsis}>
              ...
            </li>
          ) : (
            <li key={page}>
              <button
                className={`${styles.pageBtn} ${
                  current === page ? styles.active : ""
                }`}
                onClick={() => handleChange(page as number)}
              >
                {page}
              </button>
            </li>
          )
        )}
      </ul>

      <button
        onClick={handleIncrease}
        disabled={current === total}
        className={styles.navBtn}
      >
        Next
        <ArrowRightIcon className={styles.rightArrow}  />
      </button>
    </nav>
  );
};

export { PaginationTwo };
